export const GET_COUNTY_LIST_SUCCESS = 'GET_COUNTY_LIST_SUCCESS';



// WEBPACK FOOTER //
// ./src/modules/Leads/Manage_retail/redux/constants/get_county_list.constants.js